export default "__VITE_ASSET__RiGU848O__"